import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  IStudiesAllStateParamsUnboxed,
  IStudyNonUrlFilterValues,
} from '@app/core/state/ui/study-table-ui.model';

import { HttpClient } from '@angular/common/http';
import {
  IncomingTableParamsDtoOfStudyFilters,
  PagedDataDtoOfStudyDetailsDto,
} from '@core/services/api-client.generated';

interface IStudiesTableService {
  postStudies([[, projectId], sendableParams]: [
    [IStudiesAllStateParamsUnboxed | IStudyNonUrlFilterValues, string],
    IncomingTableParamsDtoOfStudyFilters
  ]): Observable<PagedDataDtoOfStudyDetailsDto>;

  getStudiesCsv([, sendableParams, project], filename: string): Observable<any>;
}

export class StudiesTableService implements IStudiesTableService {
  postStudies([[, projectId], sendableParams]: [
    [IStudiesAllStateParamsUnboxed | IStudyNonUrlFilterValues, string],
    IncomingTableParamsDtoOfStudyFilters
  ]): Observable<PagedDataDtoOfStudyDetailsDto> {
    return undefined;
  }

  getStudiesCsv(
    [, sendableParams, project]: readonly [any, any, any],
    filename: string
  ): Observable<any> {
    return undefined;
  }

  getTableData([[, projectId], sendableParams]: [
    [IStudiesAllStateParamsUnboxed | IStudyNonUrlFilterValues, string],
    IncomingTableParamsDtoOfStudyFilters
  ]): Observable<PagedDataDtoOfStudyDetailsDto> {
    return undefined;
  }
}

@Injectable({ providedIn: 'root' })
export class StudiesTableHttpService implements StudiesTableService {
  constructor(private _http: HttpClient) {}

  getTableData([[, projectId], sendableParams]: [
    [IStudiesAllStateParamsUnboxed | IStudyNonUrlFilterValues, string],
    IncomingTableParamsDtoOfStudyFilters
  ]): Observable<PagedDataDtoOfStudyDetailsDto> {
    return this._http.post<PagedDataDtoOfStudyDetailsDto>(
      `/projects/${projectId}/studies`,
      sendableParams
    );
  }

  getStudiesCsv(
    [, sendableParams, project],
    filename: string
  ): Observable<any> {
    return this._http.post(
      `/datatables/getstudiescsv/${project!.id}`,
      sendableParams.filters,
      { responseType: 'blob' }
    );
  }

  postStudies([[, projectId], sendableParams]: [
    [IStudiesAllStateParamsUnboxed | IStudyNonUrlFilterValues, string],
    IncomingTableParamsDtoOfStudyFilters
  ]): Observable<PagedDataDtoOfStudyDetailsDto> {
    return undefined;
  }
}

export interface IColumnDef {
  name: string;
  label: string;
  tooltip?: string;
  width?: string;
  sortable?: boolean;
  stageDependent: boolean;
  filterName?: string;
  urlFilter?: boolean;
  actions?: boolean;
}
